// @ts-ignore
import axios from 'axios/dist/axios.js'

const base = '/api'

const instance = axios.create({
  baseURL: base,
  timeout: 5000
  // headers: {'X-Custom-Header': 'foobar'},
})

// @ts-ignore
instance.interceptors.request.use((config) => {
  if (config.url.indexOf('/') === 0) {
    const user = instance.getUser()
    if (user) {
      // @ts-ignore
      config.headers.common.Authorization = 'Bearer ' + user.token
    }
  }
  return config
})

// @ts-ignore
instance.setUser = (user) => {
  instance.user = user
  localStorage.gigUser = JSON.stringify(user)
  // console.log('setUser: ', localStorage.gigUser)
}

instance.getUser = () => {
  if (!instance.user) {
    if (localStorage.gigUser) {
      instance.user = JSON.parse(localStorage.gigUser)
    }
  }
  // console.log('getUser:', instance.user)
  return instance.user
}

export default instance
